// extracted by css-extract-rspack-plugin
export default {"MPSegmentedContainer":"MPSegmentedContainer-oH_ENv","mpSegmentedContainer":"MPSegmentedContainer-oH_ENv"};